// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/quest/fp_ready_bg.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/quest/fp_ready_char.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 사진찍기 수행 흐름 — 화면 ② 인사말 · ③ 준비
 * 권위: docs/2026-08-14-funny-photo-mission-flow-dev-steps.md
 * Figma 3366:44224(②) · 3270:46495(③) — 둘 다 프레임 1920x1200, 2026-08-14 취득.
 *
 * 🔴 절대 px 을 쓰지 않고 \`--fpf-u\`(vw 환산)로 잡는다 — 이 화면들은 1280x800 과
 *    1920x1200 두 해상도를 함께 쓴다. 피그마 절대좌표를 그대로 옮기면 한쪽이 깨진다.
 *
 * 🔴 화면 ① 인트로는 여기에 없다. 디자인(3379:44332)이 OX 인트로(3229:42024)와 같아
 *    \`MissionIntroVideoScreen\` + \`OxQuizFlow.css\` 를 그대로 쓴다. 예전의 검은 배경
 *    전면 재생(\`.fp-logo-video\`)은 그 디자인이 아니어서 2026-08-14 에 걷어냈다.
 *
 * 회귀 가드: FunnyPhotoFlowScreens.test.jsx
 */

/* ══════════════ 화면 ② 인사말 ══════════════
   촬영 안내 영상의 첫 프레임은 화면 전체에 정지 표시하고 문구만 위에 얹는다. */
.fp-greet {
  /* 🔴 쓰는 자리에서 정의한다. 조상 상속에 기대면 조상이 바뀌는 순간 calc() 가
     통째로 무효가 되고 요소가 브라우저 기본 크기로 쪼그라든다(2026-08-13 실측 결함). */
  --fpf-u: calc(100vw / 1920);

  background: #fff;
}

.fp-greet-guide-still {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 0;
  background: #fff;
  pointer-events: none;
}

.fp-greet-copy {
  position: absolute;
  z-index: 1;
  left: calc(160 * var(--fpf-u));
  top: calc(185 * var(--fpf-u));
  width: calc(1600 * var(--fpf-u));
  text-align: center;
  font-family: 'Katuri', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-weight: 700;
}

.fp-greet-loading {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: calc(32 * var(--fpf-u));
  color: #078b21;
  font-size: calc(36 * var(--fpf-u));
}

/* display:none은 WebView의 프레임 준비를 중단할 수 있어 화면 밖에서 준비한다. */
.fp-video-preparing {
  position: fixed;
  width: 2px;
  height: 2px;
  left: -10000px;
  top: 0;
  overflow: hidden;
  pointer-events: none;
  visibility: visible;
}
.fp-video-preparing .oxq-screen { position: absolute; inset: 0; }
.fp-video-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: #fff9ec;
  color: #245b3c;
  text-align: center;
  padding: 32px;
}
.fp-video-error h2 { font-size: clamp(26px, 3vw, 48px); margin: 0; }
.fp-video-error p { font-size: clamp(18px, 1.8vw, 28px); margin: 0; }
.fp-video-error-actions { display: flex; gap: 16px; margin-top: 16px; }
.fp-video-error button, .fp-greet-loading button {
  border: 0;
  border-radius: 12px;
  background: #008b67;
  color: white;
  padding: 16px 28px;
  font-size: clamp(18px, 1.5vw, 24px);
  cursor: pointer;
}
.fp-video-error button:focus-visible, .fp-greet-loading button:focus-visible {
  outline: 3px solid #ff931e;
  outline-offset: 4px;
}

.fp-greet-name,
.fp-greet-lines {
  margin: 0;
  line-height: 1.25;
  color: #078b21;
}

.fp-greet-name {
  font-size: calc(92 * var(--fpf-u));
}

.fp-greet-name span {
  color: #ff5816;
}

.fp-greet-lines {
  margin-top: calc(34 * var(--fpf-u));
  font-size: calc(82 * var(--fpf-u));
}

/* ══════════════ 화면 ③ 준비 (Figma 3270:46495) ══════════════ */
.fp-ready {
  --fpf-u: calc(100vw / 1920);

  background: #000;
}

/* 숲 배경 — Figma 는 1920x1200 전면에 \`size-full\` 만 주므로 늘려 채운다(object-fit 기본값). */
.fp-ready-bg {
  position: absolute;
  inset: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: 100% 100%;
  pointer-events: none;
}

/* 좌하단 다람쥐 — Figma x-50 y638, 740x565. 화면 왼쪽으로 50 흘러나가 잘린다.
   🔴 **사방 크롭이 있다**(left -15.4% / top -8.27% / width 132.87% / height 115.97%).
      환산: 그림 983.2x655.2 를 (-114, -46.7) 에서 시작해 창에 물린다. */
.fp-ready-char {
  position: absolute;
  left: calc(-50 * var(--fpf-u));
  top: calc(638 * var(--fpf-u));
  width: calc(740 * var(--fpf-u));
  height: calc(565 * var(--fpf-u));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: calc(983.2 * var(--fpf-u)) calc(655.2 * var(--fpf-u));
  background-position: calc(-114 * var(--fpf-u)) calc(-46.7 * var(--fpf-u));
  pointer-events: none;
}

/* 문구 — Figma x1020(중심) y405, 184px, 줄간 1.3.
   🔴 **중앙정렬은 음수 마진으로 한다.** 이 저장소에서 translateX(-50%) 가 애니메이션에
      덮어써져 좌표가 튄 전례가 있다(2026-07-31).

   🔴 **흰 테두리는 Figma MCP 가 CSS 로 내보내지 않는다.** get_design_context 응답에는
      색·크기만 있고 stroke 가 없어서, 코드만 보고 옮기면 테두리가 통째로 사라진다
      (2026-08-12 에 같은 함정을 밟았다 - 커밋 b1bea91). 참조 렌더를 픽셀로 재보고
      맞춰야 한다: 참조의 흰 띠 두께가 9px 이고 14/17/19/22 를 실측 스윕한 결과
      **19 에서 띠 9px 로 일치**했다(평균 채널차이 8.10 -> 1.64).
      ⚠️ 두께는 글자 크기에 비례하지 않는다 - 다른 화면 값을 환산해 쓰지 말고 그때그때 잰다. */
.fp-ready-text {
  position: absolute;
  left: calc(1020 * var(--fpf-u));
  top: calc(405 * var(--fpf-u));
  width: calc(1200 * var(--fpf-u));
  margin: 0 0 0 calc(-600 * var(--fpf-u));
  font-size: calc(184 * var(--fpf-u));
  line-height: 1.3;
  text-align: center;
  white-space: nowrap;
  -webkit-text-stroke: calc(19 * var(--fpf-u)) #fff;
  paint-order: stroke fill;
}

.fp-ready-text p {
  margin: 0;
}

.fp-ready-line-go {
  color: #007800;
}

.fp-ready-line-start {
  color: #ff5816;
}
`, "",{"version":3,"sources":["webpack://./src/components/quest/FunnyPhotoMissionFlow.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;EAaE;;AAEF;gDACgD;AAChD;EACE;0DACwD;EACxD,2BAA2B;;EAE3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,gFAAgF;EAChF,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,kCAAkC;AACpC;;AAEA,yDAAyD;AACzD;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,cAAc;EACd,MAAM;EACN,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA,kCAAkC,kBAAkB,EAAE,QAAQ,EAAE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;AACA,qBAAqB,iCAAiC,EAAE,SAAS,EAAE;AACnE,oBAAoB,mCAAmC,EAAE,SAAS,EAAE;AACpE,0BAA0B,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACtE;EACE,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,6DAA6D;AAC7D;EACE,2BAA2B;;EAE3B,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,QAAQ;EACR,6DAAgE;EAChE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;;yDAEyD;AACzD;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,yDAA8D;EAC9D,4BAA4B;EAC5B,sEAAsE;EACtE,yEAAyE;EACzE,oBAAoB;AACtB;;AAEA;;;;;;;;;4DAS4D;AAC5D;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,uCAAuC;EACvC,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,wBAAwB;AAC1B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/**\n * 사진찍기 수행 흐름 — 화면 ② 인사말 · ③ 준비\n * 권위: docs/2026-08-14-funny-photo-mission-flow-dev-steps.md\n * Figma 3366:44224(②) · 3270:46495(③) — 둘 다 프레임 1920x1200, 2026-08-14 취득.\n *\n * 🔴 절대 px 을 쓰지 않고 `--fpf-u`(vw 환산)로 잡는다 — 이 화면들은 1280x800 과\n *    1920x1200 두 해상도를 함께 쓴다. 피그마 절대좌표를 그대로 옮기면 한쪽이 깨진다.\n *\n * 🔴 화면 ① 인트로는 여기에 없다. 디자인(3379:44332)이 OX 인트로(3229:42024)와 같아\n *    `MissionIntroVideoScreen` + `OxQuizFlow.css` 를 그대로 쓴다. 예전의 검은 배경\n *    전면 재생(`.fp-logo-video`)은 그 디자인이 아니어서 2026-08-14 에 걷어냈다.\n *\n * 회귀 가드: FunnyPhotoFlowScreens.test.jsx\n */\n\n/* ══════════════ 화면 ② 인사말 ══════════════\n   촬영 안내 영상의 첫 프레임은 화면 전체에 정지 표시하고 문구만 위에 얹는다. */\n.fp-greet {\n  /* 🔴 쓰는 자리에서 정의한다. 조상 상속에 기대면 조상이 바뀌는 순간 calc() 가\n     통째로 무효가 되고 요소가 브라우저 기본 크기로 쪼그라든다(2026-08-13 실측 결함). */\n  --fpf-u: calc(100vw / 1920);\n\n  background: #fff;\n}\n\n.fp-greet-guide-still {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border: 0;\n  background: #fff;\n  pointer-events: none;\n}\n\n.fp-greet-copy {\n  position: absolute;\n  z-index: 1;\n  left: calc(160 * var(--fpf-u));\n  top: calc(185 * var(--fpf-u));\n  width: calc(1600 * var(--fpf-u));\n  text-align: center;\n  font-family: 'Katuri', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  font-weight: 700;\n}\n\n.fp-greet-loading {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: calc(32 * var(--fpf-u));\n  color: #078b21;\n  font-size: calc(36 * var(--fpf-u));\n}\n\n/* display:none은 WebView의 프레임 준비를 중단할 수 있어 화면 밖에서 준비한다. */\n.fp-video-preparing {\n  position: fixed;\n  width: 2px;\n  height: 2px;\n  left: -10000px;\n  top: 0;\n  overflow: hidden;\n  pointer-events: none;\n  visibility: visible;\n}\n.fp-video-preparing .oxq-screen { position: absolute; inset: 0; }\n.fp-video-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  background: #fff9ec;\n  color: #245b3c;\n  text-align: center;\n  padding: 32px;\n}\n.fp-video-error h2 { font-size: clamp(26px, 3vw, 48px); margin: 0; }\n.fp-video-error p { font-size: clamp(18px, 1.8vw, 28px); margin: 0; }\n.fp-video-error-actions { display: flex; gap: 16px; margin-top: 16px; }\n.fp-video-error button, .fp-greet-loading button {\n  border: 0;\n  border-radius: 12px;\n  background: #008b67;\n  color: white;\n  padding: 16px 28px;\n  font-size: clamp(18px, 1.5vw, 24px);\n  cursor: pointer;\n}\n.fp-video-error button:focus-visible, .fp-greet-loading button:focus-visible {\n  outline: 3px solid #ff931e;\n  outline-offset: 4px;\n}\n\n.fp-greet-name,\n.fp-greet-lines {\n  margin: 0;\n  line-height: 1.25;\n  color: #078b21;\n}\n\n.fp-greet-name {\n  font-size: calc(92 * var(--fpf-u));\n}\n\n.fp-greet-name span {\n  color: #ff5816;\n}\n\n.fp-greet-lines {\n  margin-top: calc(34 * var(--fpf-u));\n  font-size: calc(82 * var(--fpf-u));\n}\n\n/* ══════════════ 화면 ③ 준비 (Figma 3270:46495) ══════════════ */\n.fp-ready {\n  --fpf-u: calc(100vw / 1920);\n\n  background: #000;\n}\n\n/* 숲 배경 — Figma 는 1920x1200 전면에 `size-full` 만 주므로 늘려 채운다(object-fit 기본값). */\n.fp-ready-bg {\n  position: absolute;\n  inset: 0;\n  background: url('../../assets/quest/fp_ready_bg.webp') no-repeat;\n  background-size: 100% 100%;\n  pointer-events: none;\n}\n\n/* 좌하단 다람쥐 — Figma x-50 y638, 740x565. 화면 왼쪽으로 50 흘러나가 잘린다.\n   🔴 **사방 크롭이 있다**(left -15.4% / top -8.27% / width 132.87% / height 115.97%).\n      환산: 그림 983.2x655.2 를 (-114, -46.7) 에서 시작해 창에 물린다. */\n.fp-ready-char {\n  position: absolute;\n  left: calc(-50 * var(--fpf-u));\n  top: calc(638 * var(--fpf-u));\n  width: calc(740 * var(--fpf-u));\n  height: calc(565 * var(--fpf-u));\n  background-image: url('../../assets/quest/fp_ready_char.webp');\n  background-repeat: no-repeat;\n  background-size: calc(983.2 * var(--fpf-u)) calc(655.2 * var(--fpf-u));\n  background-position: calc(-114 * var(--fpf-u)) calc(-46.7 * var(--fpf-u));\n  pointer-events: none;\n}\n\n/* 문구 — Figma x1020(중심) y405, 184px, 줄간 1.3.\n   🔴 **중앙정렬은 음수 마진으로 한다.** 이 저장소에서 translateX(-50%) 가 애니메이션에\n      덮어써져 좌표가 튄 전례가 있다(2026-07-31).\n\n   🔴 **흰 테두리는 Figma MCP 가 CSS 로 내보내지 않는다.** get_design_context 응답에는\n      색·크기만 있고 stroke 가 없어서, 코드만 보고 옮기면 테두리가 통째로 사라진다\n      (2026-08-12 에 같은 함정을 밟았다 - 커밋 b1bea91). 참조 렌더를 픽셀로 재보고\n      맞춰야 한다: 참조의 흰 띠 두께가 9px 이고 14/17/19/22 를 실측 스윕한 결과\n      **19 에서 띠 9px 로 일치**했다(평균 채널차이 8.10 -> 1.64).\n      ⚠️ 두께는 글자 크기에 비례하지 않는다 - 다른 화면 값을 환산해 쓰지 말고 그때그때 잰다. */\n.fp-ready-text {\n  position: absolute;\n  left: calc(1020 * var(--fpf-u));\n  top: calc(405 * var(--fpf-u));\n  width: calc(1200 * var(--fpf-u));\n  margin: 0 0 0 calc(-600 * var(--fpf-u));\n  font-size: calc(184 * var(--fpf-u));\n  line-height: 1.3;\n  text-align: center;\n  white-space: nowrap;\n  -webkit-text-stroke: calc(19 * var(--fpf-u)) #fff;\n  paint-order: stroke fill;\n}\n\n.fp-ready-text p {\n  margin: 0;\n}\n\n.fp-ready-line-go {\n  color: #007800;\n}\n\n.fp-ready-line-start {\n  color: #ff5816;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
